import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {UsuarioModule} from "./usuario/usuario.module";
import {LoginComponent} from "./login/login.component";

const routes: Routes = [
  { path: 'usuario', loadChildren: () => UsuarioModule},
  { path: 'login', component: LoginComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
